// extracted by mini-css-extract-plugin
module.exports = {"Container":"PartnershipExpert_Container__kCKTb","Item":"PartnershipExpert_Item__24qZH"};